// @flow
import cookieUtils from '../../utils/cookieUtils';
import {
    LOCATION_COOKIE,
    getLocationCookieKeywords,
    getWindowLocation
} from '../../utils/locationData';

import type {SearchQueryCompleteAction} from '../../actions/searchQuery';
import type {Store} from '../../reducers/index';

export default function setLocationData(
    store: Store,
    {payload}: SearchQueryCompleteAction
) {
    const state = store.getState();
    const location = getWindowLocation();
    if (payload.results && location) {
        const {pathname, search} = location;
        // read the new typeaheadSuggestion from `payload.results` and not
        // redux, because the redux state's typeaheadSuggestion won't have
        // updated until after this middleware runs!
        const lbsKeywords = getLocationCookieKeywords(
            state.searchParams.params.q,
            payload.results.typeaheadSuggestion
        );

        // convert `http://www.vrbo.com/search` -> `/search`
        let lastSearchUrl = pathname + search;

        // IE11 doesn't prepend '/'
        // c.f. https://caniuse.com/#feat=mdn-api_location_pathname
        if (lastSearchUrl[0] !== '/') {
            lastSearchUrl = `/${lastSearchUrl}`;
        }

        cookieUtils.writeCookie(LOCATION_COOKIE, {lbsKeywords, lastSearchUrl});
    }
}
